import { ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { AnalyticsService, APP_SETTINGS, AuthService, UtilityService } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { SettingService } from 'src/app/core/services/settings/settings.service';
import { isExternalThirdPartyHost } from 'src/app/shared/utils/utils';
import { AdminService } from '../admin/admin.service';
import { PaypalService } from '../paypal-login/paypal.service';
import { UserProfileService } from '../user-profile/user-profile.service';
import { NgIf, NgStyle, NgFor, DatePipe } from '@angular/common';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';





@Component({
    selector: 'app-user-login',
    templateUrl: './user-login.component.html',
    styleUrls: ['./user-login.component.css', '../paypal-login/paypal-login.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        NgStyle,
        RouterLink,
        FormsModule,
        ReactiveFormsModule,
        NgFor,
        FaIconComponent,
        DatePipe,
    ],
})
export class UserLoginComponent implements OnInit {

  faFilePdf = faFilePdf

  screenWidth: number;
  rememberUserEmail = false;
  userEmail: string;
  APP_SETTINGS: any;
  public is3rdParty: boolean = isExternalThirdPartyHost();
  public password;

  openParts24Link(): void {
    window.open(this.settingService.getAppSettings().parts24LoginLink, '_blank');
  }

  public showPaypalButton = false;

  @ViewChild('inputPassword')
  public inputPassword: ElementRef;

  @ViewChild('forgotUsernameModal')
  public forgotUsernameModal: ElementRef;

  public user: any;
  private subscription: ISubscription[];
  public allMessages: any[];

  public loginForm = new UntypedFormGroup({});
  public show = false;
  public type;

  public errorMessage = '';
  public forgotUserErrorMessage = '';
  private makeName: string;
  qid: any;
  private returnURL = '';

  //Paypal Related Variables
  public addScript = false;
  public paypalLoad = true;

  public tisSubscriptions: any;

  public selectedSubscriptionObj;

  constructor(
    private readonly utilityService: UtilityService,
    private readonly paypalService: PaypalService,
    private readonly fb: UntypedFormBuilder,
    private readonly adminService: AdminService,
    private readonly userProfileService: UserProfileService,
    private readonly authService: AuthService,
    private readonly analyticsService: AnalyticsService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly settingService: SettingService) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    this.subscription = [];
    this.APP_SETTINGS = APP_SETTINGS;
    if (APP_SETTINGS.isBMW === 'true') {
      this.makeName = 'BMW';
    } else if (APP_SETTINGS.isMINI === 'true') {
      this.makeName = 'MINI';
    } else if (APP_SETTINGS.isMOTORRAD === 'true') {
      this.makeName = 'MOTORRAD';
    } else if (APP_SETTINGS.isRollsRoyce === 'true') {
      this.makeName = 'ROLLSROYCE';
    } else {
      this.makeName = 'BMW';
    }

    this.subscription.push(this.paypalService.getAllSubcriptions(this.makeName).subscribe(data => {
      this.tisSubscriptions = data;
      this.errorMessage = '';
      this.selectedSubscriptionObj = this.tisSubscriptions[0];
    },
      error => {
        this.errorMessage = error.error.message;
      }));

    this.loginForm = this.fb.group({
      qid: new UntypedFormControl('', Validators.required),
      password: new UntypedFormControl('', Validators.required),
    });

    this.getAllMessages();
  }


  getAllMessages() {

    this.adminService.getAllPublicMessages(this.makeName).subscribe(data => {
      if (data.length > 0) {
        this.allMessages = data;
        this.allMessages = this.allMessages.filter(message => {
          if (message.hasOwnProperty('location')) {
            return message['location'].toUpperCase() === 'LOGIN';
          }
        });
        this.allMessages.sort((a, b) => {
          if (a['createdDate'] < b['createdDate']) {
            return 1;
          } else if (a['createdDate'] > b['createdDate']) {
            return -1;
          } else {
            return 0;
          }
        });
      }
    });
  }
  submitEmail(email: string) {
    this.makeName = APP_SETTINGS.isMINI == 'true' ? 'MINI' : APP_SETTINGS.isRollsRoyce == 'true' ? 'ROLLSROYCE' : 'BMW';
    this.userProfileService.forgotUsername(email, this.makeName).subscribe(responseData => {
      this.forgotUserErrorMessage = '';
      this.forgotUsernameModal.nativeElement.click();
    },
      error => {
        this.forgotUserErrorMessage = error.error.message;
        this.errorMessage = '';
      });
  }
  togglePasswordDisplay() {
    this.show = !this.show;
    if (this.show) {
      this.inputPassword.nativeElement.type = 'text';
    } else {
      this.inputPassword.nativeElement.type = 'password';
    }
  }
  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  login() {
    this.forgotUserErrorMessage = '';
    this.userProfileService.userLogin({ 'qID': this.loginForm.get('qid').value, 'password': btoa(this.loginForm.get('password').value) }, APP_SETTINGS.brandType).subscribe(data => {
      this.errorMessage = '';
      this.initializeUserInfo();
    },
      error => {
        this.handleAuthError(error)
      });
  }

  handleAuthError(error) {
    this.errorMessage = error.error?.details?.[0];
    if (error.error.message === 'ACCOUNT_EXPIRED') {
      this.router.navigate(['/paypal-login'], { queryParams: { user: this.loginForm.get('qid').value } });
    } else if (error.error.message === 'INVALID_ACCOUNT') {
      this.router.navigateByUrl('/login');
    } else if (error.error.message === 'PASSWORD_EXPIRED') {
      alert('Your password has expired. Please reset your password to continue.');
      this.router.navigate(['/reset-password'], { queryParams: { userId: this.loginForm.get('qid').value } });
    }
  }

  public getMappingUrl(parm: string): string {
    let mappingUrl = this.utilityService.getMappingUrl(parm);
    return mappingUrl['url'];
  }

  initializeUserInfo() {
    let brandType;
    this.userProfileService.getUserRoles().subscribe(data => {

      if (data.hasOwnProperty('username')) {
        brandType = data['isMini'];
        if (APP_SETTINGS.isRollsRoyce === 'true') {
          brandType = data['isRollsRoyce'];
        }
        APP_SETTINGS.isAdmin = data.isAdmin;
        APP_SETTINGS.isMotorradAdmin = data.isMotorradAdmin;
        APP_SETTINGS.isExternal = data.isExternal;
        APP_SETTINGS.isBPMAdmin = data.isBPMAdmin;
        APP_SETTINGS.isMasterAdmin = data.isMasterAdmin;
        APP_SETTINGS.isPartAdmin = data.isPartAdmin;
        APP_SETTINGS.isSIBAdmin = data.isSIBAdmin;
        APP_SETTINGS.sessionId = data.sessionId;
        APP_SETTINGS.isRollsRoyceAdmin = data.isRollsRoyceAdmin;
        APP_SETTINGS.isDealer = data.isDealer;
        APP_SETTINGS.isMOTORRAD = data.isMotorrad;

        if (data.isMini === 'true') {
          APP_SETTINGS.videoThumbnail = APP_SETTINGS.miniVideoThumbnail;
          APP_SETTINGS.videoThumbnailHeight = "45px";
          APP_SETTINGS.videoThumbnailWidth = "20px";
        }
        if (data.isRollsRoyce === 'true') {
          APP_SETTINGS.videoThumbnail = APP_SETTINGS.rollsRoyceVideoThumbnail;
          APP_SETTINGS.videoThumbnailHeight = "45px";
          APP_SETTINGS.videoThumbnailWidth = "20px";
        }
        this.authService.setUserSession('USER_INFO', JSON.stringify(data));

        if (APP_SETTINGS.brandType != brandType) {
          this.userProfileService.hideOrShowNavbar(true);
          this.router.navigated = false;
          this.router.navigateByUrl('/login');

        } else {
          this.userProfileService.hideOrShowNavbar(false);

          this.route.queryParams.subscribe(params => {
            this.returnURL = params['returnUrl'];
          });

          this.router.navigated = false;


          if (this.returnURL && this.returnURL != null) {
            this.router.navigateByUrl(this.returnURL);
          } else {
            this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
              this.analyticsService.trackExternalUserLocation('3rd Party', userData['address1'], userData['city'], userData['state'], userData['zipCode']);
              if (this.screenWidth > 767) {
                this.analyticsService.trackExternalUserLoginWebHits('3rd Party', userData['address1'], userData['city'], userData['state'], userData['zipCode'])
              } else if (this.screenWidth > 319 && this.screenWidth < 767) {
                this.analyticsService.trackExternalUserLoginMobileHits('3rd Party', userData['address1'], userData['city'], userData['state'], userData['zipCode'])
              }
            });
            this.router.navigateByUrl('/disclaimer');
          }
        }
      }
    },
      error => {
        this.errorMessage = error.error.message;
      });

  }

}
